import { render, staticRenderFns } from "./FixedBottomFilterBlock.vue?vue&type=template&id=4afee128&scoped=true&"
import script from "./FixedBottomFilterBlock.vue?vue&type=script&lang=js&"
export * from "./FixedBottomFilterBlock.vue?vue&type=script&lang=js&"
import style0 from "./FixedBottomFilterBlock.vue?vue&type=style&index=0&id=4afee128&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4afee128",
  null
  
)

export default component.exports